import { composeWithDevTools } from 'redux-devtools-extension';
import { applyMiddleware, createStore, Middleware } from 'redux';
import rootReducer, { RootState } from '@redux/modules/reducer';
import queryString from 'query-string';
import { createLogger } from 'redux-logger';
import { defaultReduxState } from '../reducers/testHelpers';
import { saveState, loadState } from './localStorage';

export function configureStoreDev(middleware: Middleware[]): ReturnType<typeof createStore> {
  // This enables ReduxDevtools Trace and expands the age limit from 50 to
  // 1000. With default settings and the amount of dispatches that are
  // occurring, you were unable to review all actions.
  const composeEnhancers = composeWithDevTools({
    trace: true,
    traceLimit: 25,
    maxAge: 1000,
  });
  const query = queryString.parse(window.location.search);

  if (query.reduxLogger === 'true') {
    middleware.push(createLogger());
  }

  if (process.env.DEV_CACHE_LOCALLY === 'true') {
    const loadedState: RootState = loadState('state') ?? defaultReduxState;

    const store = createStore(
      rootReducer,
      {
        ...loadedState,
        authentication: {
          ...loadedState.authentication,
          // This gets saved as a string, so we convert it back to a date.
          lastSessionRenewed: loadedState.authentication.lastSessionRenewed
            ? new Date(loadedState.authentication.lastSessionRenewed)
            : null,
        },
        save: {
          ...loadedState.save,
          // This gets saved as a string, so we convert it back to a date.
          saved: new Date(loadedState.save.saved),
        },
      },
      composeEnhancers(applyMiddleware(...middleware))
    );

    store.subscribe(() => {
      saveState('state', (store.getState() as unknown) as RootState);
    });

    return store;
  }

  return createStore(rootReducer, composeEnhancers(applyMiddleware(...middleware)));
}
